export const GOOGLE_MEET_WEB_URL = "https://meet.google.com";
